import { Dictionary } from "./Dictionary";
var comp_name_config = {};

comp_name_config.GameList = {
    XKBY: 1001,
    JDBY: 1002
};

comp_name_config.JDB = {
  "comp": ["JDBCNY","JDBMYR","JDBSGD","JDBRUB","JDBINR","JDBVNDK","JDBHKD","JDBBRL","JDBVND","JDBKRW","JDBPHP","JDBUSDT","JDBUSD","JDBTHB","JDBDEM",
    "jdbtest", "JDBTH-test", "JDBDEM-test", "JDBUSD-test", "JDBUSDT-test", "JDBPHP-test", "JDBKRW-test", "JDBVND-test", "JDBBRL-test", "JDBHKD-test", "JDBVNDK-test", "JDBINR-test", "JDBRUB-test", "JDBSGD-test", "JDBMYR-test"
  ],
  "pretix": "_jdb"
}

var comp_dict = comp_name_config.game_config = new Dictionary();
comp_dict.setObject(comp_name_config.GameList.XKBY, [comp_name_config.JDB]);
comp_dict.setObject(comp_name_config.GameList.JDBY, [comp_name_config.JDB]);

export { comp_name_config }



//////////////////
// WEBPACK FOOTER
// ./untils/comp_name_config.js
// module id = null
// module chunks = 